<script lang="ts">
    import { _ } from 'svelte-i18n';

    import ColumnSelectElement from './ColumnSelectElement.svelte';
    import Checkbox from '../Checkbox/Checkbox.svelte';
    import TemplateSection from './TemplateSection.svelte';
    import { SelectManager } from './SelectManager';

    export let section: string;
    export let validateForm: () => void;
    export let title: string;

    export let sm: SelectManager;
</script>

<TemplateSection>
    <div slot="section-title">{$_(title)}</div>
    <div
        slot="section-items"
        style="width: 100%; display:flex; flex-direction: column; row-gap: 5px;"
    >
        {#each sm.getElementsFromSection(section) as element, index (element.id)}
            {#if element.type === 'checkbox'}
                <div class="checkbox-container" data-disabled={element?.enabled ? 'false' : 'true'}>
                    <Checkbox
                        label={element.label}
                        checked={element.checked}
                        disabled={!element.enabled}
                        onChange={() => {
                            if (element.type === 'checkbox') {
                                element.checked = !element.checked;
                            } else {
                                throw new Error('Element type is not checkbox: ' + element.label);
                            }
                        }}
                    />
                </div>
            {:else}
                <ColumnSelectElement {element} {validateForm} bind:sm />
            {/if}
        {/each}
    </div>
</TemplateSection>

<style>
    .checkbox-container {
        margin-left: 60px;
    }
</style>
